import { CardWrapper } from 'foundations-components/transitional/components/Card';
import ErrorBoundary from 'reporting-action-components/utils/ErrorBoundary';
import ReportCardHeader from './ReportCardHeader';
import { ADD_ONS } from './constants/ReportCardOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReportCardCustomInternal({
  children,
  appUsageTracker,
  header,
  subheader,
  footer,
  errorRenderer,
  blockSize,
  additionalReportActions = [],
  addOns = [],
  isReportActionsDisabled
}) {
  const body = /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: errorRenderer,
    children: children
  });
  if (addOns.includes(ADD_ONS.DISABLE_CARD_WRAPPER)) return body;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-test-id": "report-card-v2--card-wrapper",
    blockSize: blockSize,
    compact: true,
    padding: addOns.includes(ADD_ONS.COMPACT_CARD) ? '300' : '500',
    margin: addOns.includes(ADD_ONS.COMPACT_CARD) ? '0' : undefined,
    children: [(header || additionalReportActions.length > 0) && /*#__PURE__*/_jsx(ReportCardHeader, {
      header: header,
      subheader: subheader,
      description: "",
      reportActions: [],
      additionalReportActions: additionalReportActions,
      appUsageTracker: appUsageTracker,
      addOns: addOns,
      setIsReportViewerIsOpen: () => {},
      isReportActionsDisabled: isReportActionsDisabled
    }), subheader, body, footer]
  });
}